// Composer keyboard policy — pure logic, easy to unit-test.
//
// Desktop (puntero fino): Enter sends, Shift+Enter inserts a newline.
// Mobile/tablet (puntero coarse): Enter inserts a newline; the Send button
// is the only submit path. This matches ChatGPT, Claude.ai and Cursor on
// mobile and prevents accidental sends mid-paragraph for a founder typing
// long prompts by thumb.

export interface ComposerKeyOptions {
  isCoarsePointer: boolean;
}

export interface ComposerKeyEvent {
  key: string;
  shiftKey: boolean;
}

export function shouldSendOnEnter(
  e: ComposerKeyEvent,
  opts: ComposerKeyOptions,
): boolean {
  if (e.key !== 'Enter') return false;
  if (e.shiftKey) return false;
  if (opts.isCoarsePointer) return false;
  return true;
}
